const ITEMS = [
  "50 states covered",
  "$39 flat fee",
  "No lawyer required",
  "USPS Certified Mail",
  "14-day deadlines",
  "Court-ready documents",
  "Maximum pettiness",
];

const Row = () => (
  <div className="flex shrink-0 items-center">
    {ITEMS.map((item) => (
      <span key={item} className="flex items-center">
        <span className="font-display uppercase tracking-[0.2em] text-sm sm:text-base font-medium text-[#FFFFFF] px-6 sm:px-10 whitespace-nowrap">
          {item}
        </span>
        <span className="w-2 h-2 bg-[#60A5FA] rotate-45 shrink-0" />
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <div
    data-testid="editorial-marquee"
    className="bg-[#111827] py-5 overflow-hidden border-y border-[#111827]"
  >
    <div className="flex w-max animate-marquee">
      <Row />
      <Row />
    </div>
  </div>
);
